module.exports = __webpack_public_path__ + "static/media/grain.c64b89d0.png";